export default {
  guestToken: null,
  loading: false,
  dashboard: {
    statistics: {
      day: {
        candidateSignUps: 0,
        companySignUps: 0,
        completedAssessments: 0,
        newLeads: [],
        expiringLeads: []
      },
      lastWeekCandidates: [],
      lastWeekRecruiters: []
    }
  },
  user: {
    token: null,
    langKey: 'EN'
  },
  candidates: {
    data: [],
    pagination: {
      currentPage: 1,
      pageSize: 12,
      pagerCount: 5,
      totalItems: 0
    }
  },
  recruiters: {
    data: [],
    pagination: {
      currentPage: 1,
      pageSize: 12,
      pagerCount: 5,
      totalItems: 0
    }
  },
  profilePositions: {
    data: []
  },
  matchmaking: {
    positions: []
  },
  origins: []
}
